import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  test: {},
};

const testRegistrationSlice = createSlice({
  name: 'testRegistration',
  initialState,
  reducers: {
    setTest: (state, action) => {
      state.test = action.payload;
    },
  },
});

export const { setTest } = testRegistrationSlice.actions;
export default testRegistrationSlice.reducer;
